import { render, staticRenderFns } from "./cert.vue?vue&type=template&id=6227fff4&scoped=true&"
import script from "./cert.vue?vue&type=script&lang=js&"
export * from "./cert.vue?vue&type=script&lang=js&"
import style0 from "./cert.vue?vue&type=style&index=0&id=6227fff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227fff4",
  null
  
)

export default component.exports